module.exports = __webpack_public_path__ + "img/S9-1.db5a8aaa.png";